module.exports = __webpack_public_path__ + "static/media/shuttle.c5c54c15.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/services/meet_and_greet/shuttle.jpg
// module id = 170
// module chunks = 0 2